import { Option } from 'api';
import { TrafficType, ProductSegment, IOptionMapped } from 'api';
import * as actions from './actionTypes';

export interface IOptionStore {
	options: IOptionMapped[];
	option?: Option;
	activeOptionTypeId?: number;
	activeTrafficType?: TrafficType;
	activeOptions?: IOptionMapped[];
	activeOptionId?: number;
	activeProductType?: ProductSegment;
	optionForm: IOptionMapped;
	isEdit: boolean;
	isLoading: boolean;
	isLoaded: boolean;
	isNew: boolean;
	error?: string;
	isSaved: boolean;
}

export const INITIAL_STATE: IOptionStore = {
	options: [],
	option: undefined,
	activeOptionTypeId: undefined,
	activeTrafficType: undefined,
	activeOptions: [],
	activeOptionId: undefined,
	activeProductType: ProductSegment.Sme,
	optionForm: {},
	isEdit: false,
	isLoading: false,
	isLoaded: false,
	isNew: false,
	error: '',
	isSaved: false
};

const OfferSearchData = (state = INITIAL_STATE, action: { type: string; payload: any }) => {
	switch (action.type) {
		case actions.GET_OPTION:
		case actions.GET_OPTIONS:
			state = {
				...state,
				isLoading: true
			};
			break;

		case actions.SET_ACTIVE_OPTION_TYPE:
			state = {
				...state,
				activeOptionTypeId: action.payload
			};
			break;

		case actions.SET_ACTIVE_TRAFFIC_TYPE:
			state = {
				...state,
				activeTrafficType: action.payload
			};
			break;

		case actions.SET_ACTIVE_PRODUCT_TYPE:
			state = {
				...state,
				activeProductType: action.payload
			};
			break;

		case actions.SET_ACTIVE_OPTION_ID:
			state = {
				...state,
				activeOptionId: action.payload,
				isEdit: true
			};
			break;

		case actions.RESET_ACTIVE_OPTION_ID:
			state = {
				...state,
				activeOptionId: undefined,
				isEdit: false
			};
			break;

		case actions.RESET_ACTIVE_OPTION_FILTERS:
			state = {
				...state,
				activeTrafficType: undefined,
				activeOptionTypeId: undefined,
				activeProductType: undefined,
				isEdit: false
			};
			break;

		case actions.SET_ACTIVE_OPTIONS:
			state = {
				...state,
				activeOptions: action.payload
			};
			break;

		case actions.RESET_ACTIVE_OPTIONS:
			state = {
				...state,
				activeOptions: [...state.options]
			};
			break;

		case actions.CLEAR_ACTIVE_OPTIONS:
			state = {
				...state,
				activeOptions: []
			};
			break;

		case actions.OPTION_WIZARD_ADD_OPTION:
			state = {
				...state,
				activeOptions: [action.payload, ...state.options]
			};
			break;

		case actions.SET_NEW_OPTION_FLAG:
			state = {
				...state,
				isNew: action.payload
			};
			break;

		case actions.SET_OPTION:
			state = {
				...state,
				option: { ...action.payload },
				isLoading: false
			};
			break;

		case actions.INSERT_OPTION_TO_STORE:
			state = {
				...state,
				options: [...action.payload, ...(state.options as IOptionMapped[])],
				isLoading: false
				//isSaved: true,
			};
			break;

		case actions.SET_OPTIONS:
			state = {
				...state,
				options: [...action.payload],
				isLoading: false,
				isLoaded: true,
				isSaved: true
			};
			break;

		case actions.UPDATE_OPTION_FORM:
			state = {
				...state,
				optionForm: action.payload
			};
			break;

		case actions.RESET_OPTION_FORM:
			state = {
				...state,
				optionForm: {}
			};
			break;

		case actions.OPTION_RESET_ALL:
			state = { ...INITIAL_STATE };
			break;

		case actions.OPTION_ERROR:
			state = {
				...state,
				error: action.payload,
				isLoading: false
			};
			break;

		case actions.OPTION_CLEAR_ERROR:
			state = {
				...state,
				error: ''
			};
			break;

		case actions.RESET_IS_SAVED:
			state = {
				...state,
				isSaved: false
			};
			break;

		default:
			state = { ...state };
			break;
	}
	return state;
};

export default OfferSearchData;
